/* Barra sticky de compra de la PDP.
   Aparece cuando el boton de agregar al carrito principal sale de vista hacia
   arriba y se esconde cuando vuelve a entrar. No agrega al carrito por su
   cuenta: reenvia el click al boton del formulario principal, asi que hereda la
   variante seleccionada, el drawer del carrito y el resto de la logica del theme. */
(function () {
  'use strict';

  var OVERLAYS = '[data-quickview], .t4s-quickview, .t4s-drawer, .t4s-modal, .mfp-content';

  function mainForm(productId) {
    var forms = document.querySelectorAll('form[action*="/cart/add"][data-productid="' + productId + '"]');
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].closest(OVERLAYS)) return forms[i];
    }
    return null;
  }

  function setup(root, cfg, form) {
    var vmap = {};
    cfg.variants.forEach(function (v) { vmap[v.id] = v; });

    var elPrice = root.querySelector('[data-satc-price]');
    var elVariant = root.querySelector('[data-satc-variant]');
    var elImg = root.querySelector('[data-satc-img]');
    var elLabel = root.querySelector('[data-satc-label]');
    var btn = root.querySelector('[data-satc-atc]');
    var qty = root.querySelector('[data-satc-qty]');
    var opts = root.querySelector('[data-satc-opts]');
    var optIndex = cfg.optionIndex;
    var container = form.closest('[data-callbackvariant]') || form.parentNode;

    function atcBtn() {
      return form.querySelector('[data-atc-form]') || form.querySelector('[name="add"]');
    }

    function currentVariant() {
      var input = form.querySelector('input[name="id"], select[name="id"]');
      var id = input ? parseInt(input.value, 10) : cfg.defaultId;
      return vmap[id] || vmap[cfg.defaultId];
    }

    function renderPrice(v) {
      elPrice.textContent = '';
      if (v.c) {
        var del = document.createElement('del');
        del.textContent = v.c;
        var ins = document.createElement('ins');
        ins.textContent = v.p;
        elPrice.appendChild(del);
        elPrice.appendChild(document.createTextNode(' '));
        elPrice.appendChild(ins);
      } else {
        elPrice.textContent = v.p;
      }
    }

    // Busca la variante que resulta de cambiar solo la opcion expuesta.
    function variantWith(value, current) {
      for (var i = 0; i < cfg.variants.length; i++) {
        var v = cfg.variants[i];
        if (v.o[optIndex] !== value) continue;
        var match = true;
        for (var j = 0; j < v.o.length; j++) {
          if (j !== optIndex && v.o[j] !== current.o[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function syncOptions(current) {
      if (!opts) return;
      var items = opts.querySelectorAll('[data-satc-opt]');
      for (var i = 0; i < items.length; i++) {
        var value = items[i].getAttribute('data-value');
        var target = variantWith(value, current);
        items[i].classList.toggle('is--active', current.o[optIndex] === value);
        items[i].classList.toggle('is--soldout', !target || !target.a);
      }
    }

    function sync() {
      var v = currentVariant();
      if (!v) return;
      syncOptions(v);
      if (elPrice) renderPrice(v);
      if (elVariant) elVariant.textContent = v.t === 'Default Title' ? '' : v.t;
      if (elImg && v.img && elImg.getAttribute('src') !== v.img) elImg.setAttribute('src', v.img);
      if (btn) {
        var main = atcBtn();
        // El modulo de bajo stock puede deshabilitar el boton principal: se refleja.
        btn.disabled = !v.a || !!(main && main.disabled);
        if (elLabel) elLabel.textContent = v.a ? cfg.btnText : cfg.soldOutText;
      }
    }

    // --- mostrar / esconder ---

    function show() { root.classList.add('is--visible'); }
    function hide() { root.classList.remove('is--visible'); }

    var io = null;
    var watched = null;

    function watch() {
      var target = atcBtn();
      if (!target || target === watched) return;
      if (io) io.disconnect();
      watched = target;
      io = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        // Solo cuenta como "pasado" cuando el boton queda por encima del viewport.
        if (!e.isIntersecting && e.boundingClientRect.top < 0) show();
        else hide();
      }, { threshold: 0 });
      io.observe(target);
    }

    if (cfg.trigger === 'offset' || !('IntersectionObserver' in window)) {
      var onScroll = function () {
        if (window.pageYOffset > cfg.offset) show(); else hide();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else {
      watch();
    }

    // --- sincronizacion con el formulario principal ---

    var pending = false;
    function queueSync() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; watch(); sync(); });
    }

    new MutationObserver(queueSync).observe(container, { childList: true, subtree: true });
    container.addEventListener('change', queueSync);
    // Los swatches del theme escriben el input por propiedad, sin evento: se
    // vuelve a leer poco despues del click.
    container.addEventListener('click', function () {
      setTimeout(sync, 60);
      setTimeout(sync, 400);
    });

    // --- selector de talla ---
    // No reimplementa la logica de variantes: reenvia el click al swatch de la
    // PDP y deja que el theme haga el resto (imagen, precio, agotados).

    if (opts) {
      opts.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-satc-opt]');
        if (!pill) return;
        var value = pill.getAttribute('data-value');

        var items = form.querySelectorAll('[data-swatch-option][data-id="' + optIndex + '"] [data-swatch-item]');
        for (var i = 0; i < items.length; i++) {
          if (items[i].getAttribute('data-value') === value) { items[i].click(); return; }
        }

        // Respaldo para productos sin swatches: mover el select de variantes.
        var target = variantWith(value, currentVariant());
        var select = form.querySelector('select[name="id"], input[name="id"]');
        if (target && select) {
          select.value = target.id;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
        }
      });
    }

    // --- cantidad ---

    if (qty) {
      root.addEventListener('click', function (e) {
        var step = e.target.closest('[data-satc-qty-minus]') ? -1 : e.target.closest('[data-satc-qty-plus]') ? 1 : 0;
        if (!step) return;
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + step);
      });
    }

    // --- agregar al carrito ---

    if (btn) {
      btn.addEventListener('click', function () {
        var target = atcBtn();
        if (!target || btn.disabled) return;
        if (qty) {
          var mainQty = form.querySelector('[data-quantity-value], input[name="quantity"]');
          if (mainQty) {
            mainQty.value = qty.value;
            mainQty.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        root.classList.add('is--loading');
        setTimeout(function () { root.classList.remove('is--loading'); }, 2500);
        target.click();
      });
    }

    document.addEventListener('cart:refresh:opend', function () {
      root.classList.remove('is--loading');
    });

    sync();
  }

  function init(root, tries) {
    if (root.dataset.satcReady) return;
    var node = document.getElementById(root.getAttribute('data-cfg'));
    if (!node) return;

    var cfg;
    try { cfg = JSON.parse(node.textContent); } catch (err) { return; }

    var form = mainForm(cfg.productId);
    if (!form) {
      // La seccion puede pintarse antes que el formulario principal.
      if ((tries || 0) < 10) setTimeout(function () { init(root, (tries || 0) + 1); }, 300);
      return;
    }

    root.dataset.satcReady = '1';
    setup(root, cfg, form);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-oh-sticky-atc]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i], 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
